import {
  Alignment,
  Direction,
  Displaying,
  Greyx,
  IconButton,
  Spacing,
  Typography,
} from "@bonusx-global/bx-design-system";
import { ChatPlusAltOutlined, TimesSolid } from "@bonusx-global/bx-icons";
import styled from "@emotion/styled";

const StyledAppBar = styled("div")({
  boxSizing: "border-box",
  display: Displaying.flex,
  flexDirection: Direction.row,
  justifyContent: Alignment.spaceBetween,
  alignItems: Alignment.center,
  padding: `${Spacing[1000]} ${Spacing[750]}`,
  width: "100%",
  height: Spacing[4000],
  borderBottom: `1px solid ${Greyx[200]}`,
});

const TitleContainer = styled("div")({
  display: Displaying.flex,
  flexDirection: Direction.column,
  alignItems: Alignment.flexStart,
  flex: 1,
});

const IconButtonsContainer = styled("div")({
  display: Displaying.flex,
  alignItems: Alignment.center,
  gap: Spacing[750],
});

interface ChatbotHeaderProps {
  title: string;
  onClose: () => void;
  showNewSessionButton: boolean;
  disableNewSessionButton?: boolean;
  onNewSession: () => void;
}

export const CREATE_NEW_AI_CHAT_BUTTON_ID = "create-new-ai-chat-button";
export const CLOSE_AI_CHAT_BUTTON_ID = "close-ai-chat-button";

export function ChatbotHeader({
  title,
  onClose,
  showNewSessionButton,
  disableNewSessionButton = false,
  onNewSession,
  ...rest
}: Readonly<ChatbotHeaderProps>) {
  return (
    <StyledAppBar {...rest}>
      <TitleContainer>
        <Typography variant="body1">{title}</Typography>
      </TitleContainer>
      <IconButtonsContainer>
        {showNewSessionButton && (
          <IconButton
            onClick={onNewSession}
            disabled={disableNewSessionButton}
            id={CREATE_NEW_AI_CHAT_BUTTON_ID}
            color="primary"
          >
            <ChatPlusAltOutlined />
          </IconButton>
        )}
        <IconButton onClick={onClose} id={CLOSE_AI_CHAT_BUTTON_ID}>
          <TimesSolid />
        </IconButton>
      </IconButtonsContainer>
    </StyledAppBar>
  );
}
